import { ManagePremiumStores } from '@/features/store-management/premium-stores/ManagePremiumStore';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/premium-stores/$manage-premium-store/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ManagePremiumStores />;
}
